import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String }

  close() {
    this.element.style.display = "none"
    this.element.remove()

    this._save(this.idValue)
  }

  _save(name) {
    fetch("/onboarding/steps", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
      body: JSON.stringify({ onboarding_step: { name: name, seen: true } }),
    })
  }
}
